<template>
  <v-img :src="imageUrl" class="image-box__image"></v-img>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapState('companyModule', {
      slug: 'slug'
    }),

    ...mapGetters('companyModule', {
      apiUrl: 'currentCompanyApiUrl'
    }),

    imageUrl() {
      return `${this.apiUrl}/file/public?slug=${this.slug}&fileName=${this.data.imageName}`;
    }
  }
};
</script>
